module.exports = __webpack_public_path__ + "img/in-dl.9711948b.svg";